// extracted by mini-css-extract-plugin
export default {"wrapper":"supporting-text-module--wrapper--c9568","error":"supporting-text-module--error--e0c9a"};